<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="cancel"
    :modal="false"
    :center="true"
    width="600px"
    :title="$t('langcfg.txtWifiConnect')"
    style="background: rgba(0, 0, 0, 0.4)"
  >
    <div v-if="needReEnterPwd" style="color: red">({{ $t("langcfg.txtWifiReEnterPwd") }})</div>
    <div
      align="left"
      style="
        padding-left: 15px;
        font-size: 35px;
        color: white;
        padding-top: 5px;
        margin-bottom: 20px;
      "
      v-text="'SSID: ' + wifiItem.ssid"
      v-if="!hasHide"
    ></div>
    <el-input
      ref="ssid"
      type="text"
      v-else
      v-model="ssid"
      @click.native.stop.prevent="handleSsidClick"
      @touchend.native.stop.prevent="handleSsidClick"
      placeholder="SSID"
    ></el-input>
    <el-input
      ref="pwd"
      @keyup.enter.native="connnect"
      v-model="passwd"
      @click.native.stop.prevent="handleClick"
      @touchend.native.stop.prevent="handleClick"
      :placeholder="$t('langcfg.txtPassword')"
      show-password
      style="margin-top: 10px"
    />
    <div v-if="alertPwd" class="pwdalert">
      {{ $t("langcfg.txtPwdsize") }}
    </div>
    <div v-if="alertSSID" class="pwdalert">
      {{ $t("langcfg.txtSSIDNO") }}
    </div>
    <el-row slot="footer" class="dialog-footer">
      <el-button type="info" @click="connnect" style="border: 1px solid">
        {{ $t("langcfg.txtConnect") }}
      </el-button>
      <el-button type="info" @click="cancel" style="border: 1px solid">
        {{ $t("langcfg.txtCancel") }}
      </el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import EVENTS from "../../../bus";

export default {
  data() {
    return {
      autoUpload: false,
      loginState: false,
      isConnBoolean: false,
      passwd: "",
      ssid: "",
      alertSSID: false,
      alertPwd: false
    };
  },
  components: {
    // InlineLoading,
  },
  props: {
    wifiItem: Object,
    show: Boolean,
    hasHide: {
      type: Boolean,
      default: false
    },
    needReEnterPwd: Boolean
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.hasHide) {
        this.$refs.pwd.focus();
      } else {
        this.$refs.ssid.focus();
      }
    });
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.passwd, (value) => {
        self.passwd = value;
      });
    },
    handleSsidClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.ssid, (value) => {
        self.ssid = value;
      });
    },
    connnect: function () {
      if (this.hasHide && this.ssid.length < 1) {
        this.alertSSID = true;
      } else if (this.passwd.length < 8) {
        this.alertSSID = false;
        this.alertPwd = true;
      } else {
        this.isConnBoolean = true;
        this.$emit("connect", this.passwd, this.ssid);
      }
    },
    cancel: function () {
      this.isLoading = false;
      this.$emit("hide");
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.loginInput {
  color: black;
  width: 80%;
  letter-spacing: 2px;
}
.pwdalert {
  font-size: 25px;
  margin-top: 5px;
  color: red;
}
.loginSelect {
  color: black;
  font-size: 25px;
  float: left;
  color: black;
  width: 60%;
  height: 52px;
}
.el-button {
  margin-left: 5%;
  font-size: @header-fs;
  min-width: 150px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/WifiPwd.vue